import { Fragment, useState, useRef } from 'react'
import callApi from '../../helpers/callapi'
import { useDispatch } from 'react-redux'
import config from '../../config'

import { Form, Card, Modal, Button, Row, Col } from 'react-bootstrap'

const PayOut = () => {
  const BANK = [
    { text: 'scb1', value: '4140957933' },
    { text: 'scb2 (ค่าใช้จ่าย / บัญชี)', value: '1542608776' },
  ]
  const bankSCB = 'SCB'
  const bankNoRef = useRef(null)
  const amountRef = useRef(null)
  const [showConfirmed, setShowConfirmed] = useState(false)
  const [checkPayOuts, setCheckPayOuts] = useState({})
  const dispatch = useDispatch()
  const [isDisabled, setIsDisabled] = useState(false)

  const payOutsCheck = async () => {
    try {
      dispatch({ type: 'loading_show' })
      const result = await callApi({
        fullURL: `${config.urlHost}/payOuts/inquire`,
        method: 'post',
        body: {
          bankName: bankSCB,
          bankNumber: bankNoRef.current.value,
          amount: amountRef.current.value,
        },
      })
      setCheckPayOuts(result)
      if (result.status) {
        setIsDisabled(true)
      }
      dispatch({ type: 'loading_hide' })
    } catch (error) {
      alert('error')
      console.log('error', error)
      dispatch({ type: 'loading_hide' })
    }
  }
  const payOutsSave = async () => {
    try {
      dispatch({ type: 'loading_show' })
      await callApi({
        fullURL: `${config.urlHost}/payOuts`,
        method: 'post',
        body: {
          accountName: checkPayOuts.PromptPayAccountName,
          accountNumber: checkPayOuts.PromptPayAccountNo,
          bankCode: checkPayOuts.ToBankID,
          amount: amountRef.current.value,
        },
      })
      bankNoRef.current.value = ''
      amountRef.current.value = ''
      setCheckPayOuts({})
      setIsDisabled(false)
      dispatch({ type: 'loading_hide' })
      alert('ทำการส่งเรียบร้อยร้อย')
    } catch (error) {
      alert('error')
      console.log('error', error)
      dispatch({ type: 'loading_hide' })
    }
  }

  return (
    <Fragment>
      <Card>
        <Card.Header>
          <Card.Title>โอนเงิน</Card.Title>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col sm={12} md={6}>
              <Form.Group>
                <Form.Label>ธนาคาร SCB</Form.Label>

                <select className="form-control" style={{ color: '#5d5d5d' }} ref={bankNoRef} disabled={isDisabled}>
                  <option value="">select...</option>
                  {BANK.map((item, i) => {
                    return (
                      <option value={item.value} key={i}>
                        {item.text}
                      </option>
                    )
                  })}
                </select>
              </Form.Group>
            </Col>
            <Col sm={12} md={6}>
              <Form.Group>
                <Form.Label>จำนวนเงิน</Form.Label>
                <input
                  className="form-control"
                  style={{ color: '#5d5d5d' }}
                  type="text"
                  placeholder="จำนวนเงิน"
                  ref={amountRef}
                  disabled={isDisabled}
                />
              </Form.Group>
            </Col>
          </Row>
          <div className="mt-3">
            <Button variant="warning light" onClick={() => payOutsCheck()}>
              ตรวจสอบ
            </Button>
            {checkPayOuts.status === false && <span className="text-danger ml-4">ข้อมูลไม่ถูกต้อง</span>}
            {checkPayOuts.status && (
              <span className="text-success ml-4">
                ข้อมูลถูกต้อง
                <span className="text-dark">
                  {' '}
                  (ชื่อ: {checkPayOuts.PromptPayAccountName}, ธนาคาร: {bankSCB}, เลขบัญชี:{' '}
                  {checkPayOuts.PromptPayAccountNo}, จำนวนเงิน: {parseInt(amountRef.current.value).toLocaleString()}{' '}
                  บาท)
                </span>
              </span>
            )}
          </div>
          <div className="mt-4 text-center">
            {checkPayOuts.status ? (
              <Button variant="primary light" onClick={() => setShowConfirmed(true)}>
                บันทึกข้อมูล
              </Button>
            ) : (
              <Button variant="primary light" disabled="disabled">
                บันทึกข้อมูล
              </Button>
            )}
          </div>
        </Card.Body>

        <Modal show={showConfirmed} centered>
          <Modal.Body>
            ยืนยันการบันทึกข้อมูล ?
            <Button variant="" className="close" onClick={() => setShowConfirmed(false)}>
              <span>&times;</span>
            </Button>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="danger light" onClick={() => setShowConfirmed(false)}>
              ยกเลิก
            </Button>
            <Button
              variant="primary light"
              onClick={() => {
                payOutsSave()
                setShowConfirmed(false)
              }}
            >
              ยืนยัน
            </Button>
          </Modal.Footer>
        </Modal>
      </Card>
    </Fragment>
  )
}
export default PayOut
